export default "__VITE_ASSET__27d3c302__"